<template>
<div>
    <fieldset>
    <legend>Type of Relationship with Issuer</legend>
      <div class="form-group" :class="errorRelation ? 'error':''">
      <label class="control-label" for="ffba_relation">I am</label>
      <select id="ffba_relation" name="ffba_relation" class="form-control" v-model="ffba.relation" @change="setVisible">
        <option value="" disabled="disabled">--Select One--</option>
        <option v-for="option in relationOptions" :value="option.name">{{ option.name }}</option>
      </select>
      </div>
      <div v-if="familyVisible">
        <div class="form-group" :class="errorName ? 'error':''">
        <label class="control-label" for="ffba_relation_name">{{ ffbaRelationLabel }}</label>
        <input type="text" id="ffba_relation_name" name="ffba_relation_name" class="form-control" v-model="ffba.relation_name" @change="updateRelationship">
        </div>
        <div class="form-group" :class="errorRole ? 'error':''">
        <label class="control-label" for="ffba_role">{{ ffbaRoleLabel }}</label>
        <input type="text" id="ffba_role" name="ffba_role" class="form-control" v-model="ffba.role">
        </div>
        <div class="form-group" :class="errorRelationship ? 'error':''" v-if="!personalVisible">
          <label class="control-label" for="ffba_relationship">{{ ffbaRelationshipLabel }}</label>
          <select id="ffba_relationship" name="ffba_relationship" class="form-control" v-model="ffba.relationship" @change="updateRelationPlaceholder">
            <option value="" disabled="disabled">--Select One--</option>
            <option v-for="option in relationshipOptions" :value="option.name">{{ option.name }}</option>
          </select>
        </div>
      </div>
        <div class="form-group" :class="errorYears ? 'error':''" v-if="personalVisible">
          <label for="ffba_relation_years" class="control-label">Number of years I have known this person</label>
          <input type="number" id="ffba_relation_years" class="form-control" name="ffba_relation_years" placeholder="Enter Number of Years" v-model="ffba.relation_years">
        </div>
    </fieldset>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    defaults: Object,
    old: ''
  },
  data() {
    return {
      ffba: {
        relation: this.old['ffba_relation'] ? this.old['ffba_relation'] : '',
        relation_name: this.old['ffba_relation_name'] ? this.old['ffba_relation_name'] : '',
        role: this.old['ffba_role'] ? this.old['ffba_role'] : '',
        relationship: this.old['ffba_relationship'] ? this.old['ffba_relationship'] : '',
        relation_years: this.old['ffba_relation_years'] ? this.old['ffba_relation_years'] : ''
      },
      ffbaRelationLabel: '',
      ffbaRoleLabel: '',
      ffbaRelationshipLabel: '',
      familyVisible: false,
      personalVisible: false,
      relationOptions: [],
      relationshipOptions: [],
      oldData: this.old ? this.old : '',
      defaultData: this.defaults ? this.defaults : {},
      errorRelation : false,
      errorName : false,
      errorRole : false,
      errorRelationship : false,
      errorYears : false,
      relationPlaceholder : '"__________"'
    }
  },
  methods: {
    setVisible() {
      if(this.ffba.relation === 'a family member') {
        this.ffbaRelationLabel = 'Name of family member'
        this.ffbaRoleLabel = 'Role or position of family member'
        this.relationPlaceholder = this.ffba.relationship ? this.ffba.relationship : this.relationPlaceholder
        this.ffbaRelationshipLabel = 'I am the ' + this.relationPlaceholder + ' of ' + this.ffba.relation_name
        this.familyVisible = true
        this.personalVisible = false
        if(_.isEmpty(this.oldData)) {
          this.setFieldError()
        }
      } else
      if(this.ffba.relation === 'a close personal friend') {
        this.ffbaRelationLabel = 'Name of close personal friend'
        this.ffbaRoleLabel = 'Role or position of close personal friend'
        this.familyVisible = true
        this.personalVisible = true
        if(_.isEmpty(this.oldData)) {
          this.setFieldError()
        }
      } else
      if(this.ffba.relation === 'a close business associate') {
        this.ffbaRelationLabel = 'Name of close business associate'
        this.ffbaRoleLabel = 'Role or position of close business associate'
        this.familyVisible = true
        this.personalVisible = true
        if(_.isEmpty(this.oldData)) {
          this.setFieldError()
        }
      } else {
        this.familyVisible = false
        this.personalVisible = false
      }
      this.oldData = ''
      this.defaultData = {}
    },
    getRelationOptions() {
        return axios.get('/ffba-relation-options')
          .then(response => {
            this.relationOptions = response.data
            return Promise.resolve()
          })
    },
    getRelationshipOptions() {
      return axios.get('/ffba-relationship-options')
          .then(response => {
            this.relationshipOptions = response.data
            return Promise.resolve()
          })
    },
    checkFieldValue() {
      this.ffba.relation === '' ? this.errorRelation = true : this.errorRelation = false
      this.ffba.relation_name === '' ? this.errorName = true : this.errorName = false
      this.ffba.role === '' ? this.errorRole = true : this.errorRole = false
      this.ffba.relationship === '' ? this.errorRelationship = true : this.errorRelationship = false
      this.ffba.relation_years === '' ? this.errorYears = true : this.errorYears = false
    },
    setFieldError() {
      this.errorRelation = false
      this.errorName = false
      this.errorRole = false
      this.errorRelationship = false
      this.errorYears = false
    },
    updateRelationship() {
      this.ffbaRelationshipLabel += this.ffba.relation_name
    },
    updateRelationPlaceholder() {
      this.relationPlaceholder = this.ffba.relationship
      this.ffbaRelationshipLabel = 'I am the ' + this.relationPlaceholder + ' of ' + this.ffba.relation_name
    }
  },
  created() {
    if(_.isEmpty(this.oldData)) {
      this.ffba.relation = this.defaultData['ffba_relation'] ? this.defaultData['ffba_relation'] : ''
      this.ffba.relation_name = this.defaultData['ffba_relation_name'] ? this.defaultData['ffba_relation_name'] : ''
      this.ffba.role = this.defaultData['ffba_role'] ? this.defaultData['ffba_role'] : ''
      this.ffba.relationship = this.defaultData['ffba_relationship'] ? this.defaultData['ffba_relationship'] : ''
      this.ffba.relation_years = this.defaultData['ffba_relation_years'] ? this.defaultData['ffba_relation_years'] : ''
    }
    if(!_.isEmpty(this.oldData)) {
      this.checkFieldValue()
    }
    this.getRelationOptions()
    this.getRelationshipOptions()
    this.setVisible()
  }
}
</script>